import { h, Fragment, } from "preact";
import { useState, useContext, useEffect, useRef } from "preact/hooks";
import styled from "styled-components";
import { createPortal, forwardRef } from 'preact/compat';
import { makeStyles } from "@mui/styles";

const Li = styled.li`
  width: 100px;
  height: 100px;
  background-color: #d3d3d3;
  border-radius: 10px;
  margin: 0.5rem;

  padding: 0;

  display: flex;
  justify-content: space-around;
  align-items: center;
  user-select: none;
`;
// const Li = styled.li`
//   width: 100px;
//   height: 100px;
//   background-color: #d3d3d3;
//   border-radius: 10px;
//   margin: 0.5rem;
//   list-style: none;
//   padding: 0;

//   display: flex;
//   justify-content: space-around;
//   align-items: center;
//   user-select: none;
// `;
const useStyles = makeStyles((theme) => ({

    ribbon: {
        boxShadow: "0 0 0 2px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
        margin: 0,
        padding: 0,
        background: "#FF3426",
        color: "white",
        padding: "2px 0",
        //padding: "1em 0",
        position: "absolute",
        top: 0,
        left: 0,
        transform: "translateX(-30%) translateY(0%) rotate(-45deg)",
        transformOrigin: "top right",
        "&:before": {
            content: '"*"',
            position: "absolute",
            top: 0,
            margin: "0 -1px",
            width: "100%",
            height: "100%",
            background: "#FF3426",
            left: "100%",
        },
        "&:after": {
            content: '"*"',
            position: "absolute",
            top: 0,
            margin: "0 -1px",
            width: "100%",
            height: "100%",
            background: "#FF3426",
            right: "100%",
        },
    },
}));
const Item2 = forwardRef(({ id, ...props }, ref) => {
    const classes = useStyles();
    // console.log("Item2", props, props.props.item.rn, props.idx == 0)
    // console.log("Item2 ", props.props)
    return (
        <Li {...props} ref={ref} id={props.props.item.uid}>
            {/* <div style={{ padding: "0px", position: "relative", overflow: "hidden" }}> */}
            {/* {props.props.item.rn == 1 && <span className={classes.ribbon}>1</span>} */}
            {/* <p>
                {props.props.text} {props.props.id}
            </p> */}
            <div onMouseOver={(e) => {
                //console.log(props.props.item.rn)
                props.props.setUpperActiveStep0(props.props.item.rn - 1)
            }}>
                <img width={100} height={100} src={props.props.item.link1}
                    style={props.props.idx == 0 ? "border: 2px solid red; border-radius: 5px;" : "border: 1px solid gray; border-radius: 5px;"}
                />
            </div>

            {/* </div> */}
        </Li >
    );
});

export default Item2;